import { AppErrorState } from "./error.state";
import * as errorActions from "./error.actions";
import { Action, createReducer, on } from "@ngrx/store";

const initialState: AppErrorState = null;

const featureReducer = createReducer(
	initialState,
	on(errorActions.setError, (state, { error }) => {
		return {
			...state,
			...error,
		};
	}),
	on(errorActions.resetError, () => initialState)
);

export function errorReducer(
	state: AppErrorState | undefined,
	action: Action
): AppErrorState | undefined {
	return featureReducer(state, action);
}
